var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRevenueLeftCornerWave(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 28,
    viewBox: "0 0 54 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.7461 0C53.0658 4.60641 48.8968 17.5599 31.7224 23.4356C15.0593 29.1364 4.0821 27.1759 0.000127929 25.3333L0.000126959 13.3045C0.0156865 5.95396 5.97924 4.5239e-06 13.3334 3.8274e-06L53.7461 0Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRevenueLeftCornerWave);
export default __webpack_public_path__ + "static/media/revenueLeftCornerWave.3138bd82601011b2552018615cede4ad.svg";
export { ForwardRef as ReactComponent };